module.exports = __webpack_public_path__ + "assets/img/11.ef03f560.png";